<template>
  <div class="page">
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="formInline" class="card-form demo-form-inline">
            <el-form-item label="工程名称">
              <el-select :clearable="true" @change="loadStationList" v-model="selectedProject" value-key="projectId">
                <el-option v-for="p in projectList" :key="p.projectId" :value="p" :label="p.projectName" />
              </el-select>
            </el-form-item>
            <el-form-item label="测站名称">
              <el-input clearable v-model="formInline.name" placeholder="测站名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="openAddStation">添加测站</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-table border :data="filterTableData">
            <el-table-column align="center" type="index" width="50" label="序号"></el-table-column>
            <el-table-column label="工程名称/ID" align="center" width="120">
              <template slot-scope="scope">
                {{ getProjectName(scope.row.projectId) }} / {{ scope.row.projectId }}
              </template>
            </el-table-column>
            <el-table-column label="测站名称/ID" align="center" width="120">
              <template slot-scope="scope">{{ scope.row.projectStationName }} / {{ scope.row.projectStationId }}
              </template>
            </el-table-column>
            <el-table-column label="是否启用" align="center" width="50">
              <template slot-scope="scope">{{
                scope.row.projectStationEnable === "true" ? "是" : "否"
              }}</template>
            </el-table-column>
            <el-table-column prop="projectStationChannelCount" align="center" label="通道总数" width="60" />
            <el-table-column prop="projectStationInterval" align="center" label="采集间隔" width="60" />
            <el-table-column prop="projectStationLatLng" align="center" label="经纬度" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="projectStationManagerPhone" align="center" label="负责人手机"></el-table-column>
            <el-table-column prop="projectStationPhone" align="center" label="物联网卡号"></el-table-column>
            <el-table-column label="是否在线" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.online" style="font-size: 32px;color:#67C23A" class="el-icon-success"></i>
                <i v-else style="font-size: 32px;color:#F56C6C" class="el-icon-error"></i>
              </template>
            </el-table-column>
            <el-table-column prop="projectStationPosition" align="center" label="位置" width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="projectStationImei" label="IMEI" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="projectStationComment" label="备注"></el-table-column>
            <el-table-column fixed="right" label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button @click="showPointList(scope.row)" type="text" size="small">查看测点</el-button>
                <el-button @click="editStation(scope.row, scope.$index)" type="text" size="small">编辑</el-button>
                <el-popconfirm style="margin-left: 10px" confirm-button-text="确定" cancel-button-text="取消"
                  icon="el-icon-info" icon-color="red" title="确定删除吗" @confirm="deleteStation(scope.row, scope.$index)">
                  <el-button type="text" size="small" slot="reference">删除</el-button>
                </el-popconfirm>
                <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
                  title="确定下发设置吗" @confirm="sendConfigToMachine(scope.row)">
                  <el-button type="text" size="small" slot="reference">设置下发</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-drawer :title="this.drawerModel === 'update' ? '编辑测站' : '添加测站'" :visible.sync="drawer" :direction="direction"
      :before-close="handleClose" class="demo-drawer" size="50%">
      <el-form ref="stationInfo" :inline="false" label-width="135px" label-position="right" :model="addFormInline"
        :rules="rules" class="demo-ruleForm" size="mini">
        <el-form-item label="测站名称" prop="projectStationName">
          <el-input v-model="addFormInline.projectStationName" placeholder="测站名称"></el-input>
        </el-form-item>
        <el-form-item label="测站编号(ID)" prop="projectStationId">
          <el-input v-model="addFormInline.projectStationId" placeholder="此处填写测站的唯一身份认证号"></el-input>
        </el-form-item>
        <div style="display:flex">
          <el-form-item label="是否启用" prop="projectStationEnable">
            <el-select clearable v-model="addFormInline.projectStationEnable" @change="checkStaionState">
              <el-option selected value="true" label="是" key="001"></el-option>
              <el-option value="false" label="否" key="003"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道总数" prop="projectStationChannelCount">
            <el-select style="width:15rem" clearable v-model="addFormInline.projectStationChannelCount">
              <el-option v-for="n in 10" :value="8*n" :label="8*n" :key="'ch-count-'+n"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display:flex">
          <el-form-item label="掉线提醒" prop="projectStationAlarmEnable">
            <el-select clearable v-model="addFormInline.projectStationAlarmEnable">
              <el-option selected value="true" label="是" key="009"></el-option>
              <el-option value="false" label="否" key="008"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="掉线超时阈值(天)" prop="projectStationAlarmInterval">
            <el-input :disabled="addFormInline.projectStationAlarmEnable==='false'" style="width:15rem" type="number" min="0"
              v-model="addFormInline.projectStationAlarmInterval" placeholder="掉线超时阈值"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="采集间隔(分钟)" prop="projectStationInterval">
          <el-input type="number" v-model="addFormInline.projectStationInterval" placeholder="采集间隔"></el-input>
        </el-form-item>
        <el-form-item label="位置" prop="projectStationPosition">
          <el-input v-model="addFormInline.projectStationPosition" placeholder="位置"></el-input>
        </el-form-item>
        <el-form-item label="经纬度" prop="projectStationLatLng">
          <el-input v-model="addFormInline.projectStationLatLng" placeholder="经度"></el-input>
          <el-button type="primary" @click="showMap = true" icon="el-icon-search">地图选择</el-button>
        </el-form-item>
        <el-form-item label="测站负责人手机" prop="projectStationManagerPhone">
          <el-input v-model="addFormInline.projectStationManagerPhone" placeholder="测站负责人手机"></el-input>
        </el-form-item>
        <el-form-item label="物联网卡号" prop="projectStationPhone">
          <el-input v-model="addFormInline.projectStationPhone" placeholder="物联网卡号"></el-input>
        </el-form-item>
        <el-form-item label="通讯模块IMEI" prop="projectStationImei">
          <el-input v-model="addFormInline.projectStationImei" placeholder="通讯模块IMEI"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="projectStationComment">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="80" show-word-limit placeholder="请输入备注信息"
            v-model="addFormInline.projectStationComment"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStation">保存</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog width="80%" :fullscreen="true" top="10vh" :visible.sync="showMap" :append-to-body="true">
      <AmapComponent :closeDialog.sync="showMap" :lngAndLat.sync="addFormInline.projectStationLatLng" />
    </el-dialog>
  </div>
</template>
<script>
import AmapComponent from "@/components/Amap";
import loadingMixin from "@/mixin/loading-mixin";
import { RULES } from "./stationPage";
import {
  addStation,
  updateStation,
  deleteStation,
  listStation
} from "@/api/stationApi";
import { listProject } from "@/api/projectApi";
import { noticeChangeRequest, sendPointConfig } from "@/api/messageApi";
import { listPoint } from "@/api/pointApi";
export default {
  components: { AmapComponent },
  data() {
    return {
      showMap: false,
      rules: RULES,
      drawerModel: "",
      selectedProject: undefined,
      projectList: [],
      stationList: [],
      formInline: {
        projectId: ""
      },
      addFormInline: {},
      drawer: false,
      direction: "rtl"
    };
  },
  mixins: [loadingMixin],
  mounted() {
    const projectId = this.$route.params.projectId;
    const projectName = this.$route.params.projectName;
    if (projectId) {
      this.formInline.projectId = projectId;
      this.formInline.projectName = projectName;
      this.selectedProject = {
        projectId: projectId,
        projectName: projectName
      };
    }
    this.showLoading();
    // 加载项目
    this.loadProjectList();
    // 加载测站
    this.loadStationList();
    setTimeout(() => this.closeLoading(), 500);
  },
  methods: {
    sendConfigToMachine(row) {
      noticeChangeRequest({
        stationId: row.projectStationId,
      }).then(res => {
        if (res.data.code !== 200) {
          this.$message.error({ showClose: true, duration: 6000, message: "配置通知失败," + res.data.msg });
        } else {
          const loading = this.$loading({
            lock: true,
            text: "配置下发中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          setTimeout(this.loadConfigSendStatue(row.projectStationId), 10000);

          setTimeout(loading.close(), 20000);
        }
      }).catch(() => {

      });
    },
    async loadConfigSendStatue(mn) {
      let queryData;
      await sendPointConfig({
        stationId: mn,
      }).then(res => {
        if (res.data.code !== 200) {
          return false;
        } else {
          queryData = JSON.parse(res.data.content);
        }
      }).catch(() => {
        this.$message.error({
          showClose: true, duration: 6000, message: "页面错误"
        });
      });
      if (!queryData) {
        return;
      }
      await listPoint({
        projectId: this.selectedProject.projectId,
        projectStationId: mn
      }).then(res => {
        let isSame = true;
        const plist = res.data.content.filter(v => v.projectPointChannel !== "0");
        plist.forEach(p => {
          const newPointCh = this.prefixZero(parseInt(p.projectPointChannel) + 30, 4);
          const newPointId = p.projectPointId;
          if (queryData[newPointCh] !== newPointId) {
            isSame = false;
          }
        });
        this.$message.success({
          showClose: true, duration: 6000, message: isSame ? "配置下发成功" : "配置下发失败"
        });
      }).catch(() => {
        this.$message.error({
          showClose: true, duration: 6000, message: "页面错误"
        });
      });
    },
    onSubmit() {
      this.showLoading();
      this.$message.success("查询成功");
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    async checkStaionState(v) {
      if (v !== "true") {
        return;
      }
      await listStation({
        projectStationId: this.addFormInline.projectStationId,
        projectStationEnable: "true"
      }).then(res => {
        const resp = res.data;
        if (resp.content) {
          if (resp.content.length > 1) {
            this.$message.error(
              this.addFormInline.projectStationId +
              "已经存在正在使用的工程，请手动关闭后再使用"
            );
          } else {
            if (resp.content[0].id !== this.addFormInline.id) {
              this.$message.error(
                this.addFormInline.projectStationId +
                "已经存在正在使用的工程，请手动关闭后再使用"
              );
            }
          }
        }
      });
    },
    openAddStation() {
      if (!this.selectedProject) {
        this.$message.error("请选择一个工程");
        return;
      }
      this.addFormInline = {
        projectStationAlarmInterval: 1
      };
      this.drawer = true;
    },
    addStation() {
      this.$refs.stationInfo.validate(valid => {
        if (valid) {
          if (this.drawerModel === "update") {
            updateStation(this.addFormInline).then(res => {
              const resp = res.data;
              if (resp.code === 200) {
                this.$message.success("更新成功");
                this.loadStationList();
              } else {
                this.$message.error(resp.msg);
              }
            });
            this.drawerModel = "";
            this.updateIndex = -1;
            this.drawer = false;
          } else {
            if (!this.selectedProject) {
              this.$message.error("请选择一个工程");
              return;
            }
            this.addFormInline.projectId = this.selectedProject.projectId;
            addStation(this.addFormInline).then(res => {
              const resp = res.data;
              if (resp.code === 200) {
                this.$message.success("创建成功");
                this.drawer = false;
                this.loadStationList();
              } else {
                this.$message.error(resp.msg);
              }
            });
          }
        }
      });
    },
    showPointList(row) {
      this.$router.push({
        path: "/point",
        query: {
          projectId: row.projectId,
          stationId: row.projectStationId,
          stationName: row.projectStationName
        }
      });
    },
    editStation(row, index) {
      this.updateIndex = index;
      this.addFormInline = row;
      this.drawer = true;
      this.drawerModel = "update";
    },
    deleteStation(row, index) {
      deleteStation(row).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.$message.success("删除成功");
          this.loadStationList();
        } else {
          this.$message.error(resp.msg);
        }
      });
    },
    loadProjectList() {
      listProject({}).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.projectList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    loadStationList() {
      if (!this.selectedProject) {
        return;
      }
      listStation({ projectId: this.selectedProject.projectId }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.stationList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    getProjectName(pid) {
      const projectList = this.projectList.find(v => v.projectId === pid);
      return projectList ? projectList.projectName : "";
    },
    prefixZero(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    }
  },
  computed: {
    filterTableData() {
      let data = this.stationList;
      if (this.formInline.name) {
        data = data.filter(v =>
          v.projectStationName.toLowerCase().includes(this.formInline.name)
        );
      }
      // if (this.formInline.projectId) {
      //   data = data.filter(v => v.projectId === this.formInline.projectId);
      // }
      return data;
    }
  }
};
</script>
<style scoped>
.page {
  margin-top: 14px;
  padding: 10px;
}
.demo-ruleForm {
  width: calc(100% - 10px);
}
.demo-drawer {
}
.card-basic {
  margin: 5px 10px;
}
.card-form .el-form-item {
  margin-bottom: 0px;
}
</style>
